import React from "react";
import { Label } from "../ui/label";
import { Slider } from "../ui/slider";

export function SliderRow({ label, unit = "", value, min, max, step = 1, onChange, formatDisplay, parseInput, testid }) {
  const [draft, setDraft] = React.useState("");
  const [editing, setEditing] = React.useState(false);

  const displayValue = formatDisplay ? formatDisplay(value) : value;
  const commit = () => {
    setEditing(false);
    const raw = parseInput ? parseInput(draft) : Number(draft);
    if (Number.isFinite(raw)) {
      const clamped = Math.min(max, Math.max(min, raw));
      onChange(clamped);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <Label className="text-xs">{label}</Label>
        {editing ? (
          <input
            data-testid={testid ? `${testid}-input` : undefined}
            autoFocus
            type="number"
            min={min}
            max={max}
            step={step}
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={commit}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); commit(); } if (e.key === "Escape") setEditing(false); }}
            className="w-20 h-6 text-xs px-2 rounded border hairline text-right focus:outline-none focus:ring-2 focus:ring-[color:var(--accent-metal)]"
          />
        ) : (
          <button
            type="button"
            data-testid={testid ? `${testid}-value` : undefined}
            onClick={() => { setDraft(String(displayValue)); setEditing(true); }}
            className="text-xs font-mono px-2 py-0.5 rounded border border-transparent hover:border-[color:var(--accent-metal)]/40 hover:bg-[color:var(--accent-metal)]/10 transition-colors"
            title="Click to type an exact value"
          >
            {displayValue}{unit}
          </button>
        )}
      </div>
      <Slider data-testid={testid} value={[value]} min={min} max={max} step={step} onValueChange={([v]) => onChange(v)}/>
    </div>
  );
}
